export default "__VITE_ASSET__Bkq1Y06N__"